import { FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import clsx from "clsx";
import { IUserOptions } from "../../../types/interfaces";

interface ISidebarLinkOptions {
  content?: string;
  chevron?: React.ReactNode;
  to?: string;
  icon?: JSX.Element;
}

const SidebarLink: FC<ISidebarLinkOptions> = ({ to, icon, chevron, content }) => {
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);
  const { darkTheme } = useSelector((state: any) => state.theme.theme);

  const pathname = window.location.pathname;

  return (
    <Link
      className={clsx(
        "sidebar__btn",
        darkTheme?.isDarkTheme ? "--dark" : "",
        pathname.includes((to as string)?.split("/")[1]) && "--active"
      )}
      to={to as string}
    >
      {icon}
      {isOpenSidebar ? (
        <>
          <span className="link">{content}</span>
          {chevron}
        </>
      ) : (
        <div className="tooltip">
          <span className="tooltip__content">{content}</span>
        </div>
      )}
    </Link>
  );
};

export default SidebarLink;
